<template>
  <b-card :title="$t('callCenter.manage')">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="موبایل"
                    label-for="Mobile"
                >
                  <b-form-input
                      v-model="filterOptions.Mobile"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت درخواست"
                    label-for="Title"
                >
                  <v-select
                      v-model="filterOptions.RequestStatus"
                      dir="rtl"
                      :reduce="x => x.value"
                      :clearable="true"
                      label="text"
                      :options="enums('RequestStatus')"
                  />
                </b-form-group>
              </b-col>
               <b-col md="2">
                <b-form-group
                    label="وضعیت اخرین تماس"
                >
                  <v-select
                      v-model="filterOptions.CallResult"
                      dir="rtl"
                      :reduce="x => x.value"
                      :clearable="true"
                      label="text"
                      :options="enums('callResultTypes')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                      :clearable="true"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                  />
                </b-form-group>
              </b-col>
                <b-col md="2">
                  <b-form-group
                      label="تا تاریخ"
                  >
                    <date-picker
                        v-model="filterOptions.ToDate"
                        :clearable="true"
                        placeholder=""
                        type="datetime"
                        format="YYYY-MM-DD HH:mm"
                        display-format="jYYYY-jMM-jDD HH:mm"
                    />
                  </b-form-group>
                </b-col>
              <b-col md="2">
                <b-form-group
                    label="نوع درخواست"
                >
                  <v-select
                      v-model="filterOptions.RequestType"
                      dir="rtl"
                      :reduce="x => x.value"
                      :clearable="true"
                      label="text"
                      :options="enums('RequestType')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت ترم"
                >
                  <v-select
                      v-model="filterOptions.ActiveTerm"
                      dir="rtl"
                      :reduce="x => x.value"
                      :clearable="true"
                      label="text"
                      :options="enums('IsActive')"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >
                {{ $t('common.filter') }}
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(Name)="data">
            <span class="text-nowrap">
              <b-link
                  :to="{ name: 'userDetail', params: { id: data.item.UserId }}"
                  class="font-weight-bold "
              >
                    <b-avatar
                        class="mr-1"
                        :src="data.item.Image"
                    />
                <span></span>
              {{ data.item.Name }} {{ data.item.Family }}
              </b-link>
              <p class="mt-1">
                <span>موبایل : </span>
                <span>{{data.item.Mobile}}</span>
              </p>
            </span>
          </template>
          <template #cell(RequestDate)="data">
            {{ data.value | date }}
          <span class="text-center">  {{ new Date(data.value).toLocaleTimeString('en-GB') | time }}</span>
          </template>
          <template #cell(HaveActiveTerm)="data">
              <b-badge v-if="data.value ===  true" variant="success">فعال</b-badge>
              <b-badge v-else variant="warning">غیر فعال</b-badge>
          </template>
          <template #cell(OrderInfo.WithActivity)="data">
              <feather-icon v-if="data.value" class="mr-1" icon="CheckSquareIcon" size="20" />
              <feather-icon v-else  class="mr-1" icon="SquareIcon" size="20" />
          </template>
          <template #cell(OrderInfo.DietType)="data">
            <p>{{data.value}}</p>
            <p v-if="data.item.OrderInfo !== null">{{data.item.OrderInfo.DayCount}}روز</p>
          </template>
          <template #cell(LastCallResult.CallResult)="data">
            <b-badge
                class="mb-1"
                :variant="enums('callResultTypes', 'value', data.value, 'badge')">
              {{ enums('callResultTypes', 'value', data.value, 'text') }}
            </b-badge>
            <div v-if="data.item.LastCallResult">
              {{ data.item.LastCallResult.CreateAt | date }}
              <span class="text-center">  {{(new Date(data.item.LastCallResult.CreateAt).toLocaleTimeString('en-GB')) | time }} </span>
            </div>
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'callCenterList', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>
            </div>
          </template>
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1" v-text="$t('common.loading')" />
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'prizeWheels',
  data() {
    return {
      totalRows: null,
      loading: false,
      filterOptions: {
        ToDate:null,
        FromDate:null,
        RequestStatus: 0,
        CallResult:null,
        Page: 1,
        PerPage: 10,
        Mobile:null,
        ActiveTerm:null,
        RequestType:null
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Name',
          label: this.$t('common.fullName'),
        },
        {
          key: 'RequestDate',
          label: this.$t('common.date'),
        },
          {
          key: 'RequestTypeText',
          label:'نوع درخواست',
        },
          {
          key: 'HaveActiveTerm',
          label: 'وضعیت ترم',
        },
    {
          key: 'OrderInfo.DietType',
          label: 'نوع رژیم',
        },

        {
          key: 'OrderInfo.WithActivity',
          label: ' ورزش',
        },
         {
          key: 'RequestStatusText',
          label: 'وضعیت درخواست ',
        },
        {
          key: 'LastCallResult.CallResult',
          label: 'وضعیت اخرین تماس',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      this.$http.get(this.$api.callRequests.getList, { params: this.filterOptions })
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>
